// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__pkkOa","container__image":"styles_container__image__XH7hQ","skeleton-animation":"styles_skeleton-animation__keI_a"};